// @ts-nocheck

import * as proto from '@safeguardproperties/proto/lambda/ml/prompt/v1/prompt_v1_pb';
import ServiceClient from './serviceClient';

export class PartClient extends ServiceClient {
  constructor(baseUrl: string, debug: boolean) {
    super(baseUrl, debug);
  }

  public async Create(
    request: proto.PromptCreateRequest
  ): Promise<proto.PromptCreateResponse> {
    return this.Post('create', request, proto.PromptCreateResponse);
  }

  public async Deactivate(
    request: proto.PromptDeactivateRequest
  ): Promise<proto.PromptDeactivateResponse> {
    return this.Post('deactivate', request, proto.PromptDeactivateResponse);
  }

  public async Replace(
    request: proto.PromptReplaceRequest
  ): Promise<proto.PromptReplaceResponse> {
    return this.Post('replace', request, proto.PromptReplaceResponse);
  }

  public async AddContext(
    request: proto.PromptAddContextRequest
  ): Promise<proto.PromptAddContextResponse> {
    return this.Post('addcontext', request, proto.PromptAddContextResponse);
  }

  public async RemoveContext(
    request: proto.PromptRemoveContextRequest
  ): Promise<proto.PromptRemoveContextResponse> {
    return this.Post(
      'removecontext',
      request,
      proto.PromptRemoveContextResponse
    );
  }

  public async SetName(
    request: proto.PromptSetNameRequest
  ): Promise<proto.PromptSetNameResponse> {
    return this.Post('setname', request, proto.PromptSetNameResponse);
  }

  public async SetDescription(
    request: proto.PromptSetDescriptionRequest
  ): Promise<proto.PromptSetDescriptionResponse> {
    return this.Post(
      'setdescription',
      request,
      proto.PromptSetDescriptionResponse
    );
  }

  public async GetPrompt(id: string): Promise<proto.PromptGetResponse> {
    return this.Get(`get/${id}`, proto.PromptGetResponse);
  }

  public async GetBulk(
    request: proto.PromptGetBulkRequest
  ): Promise<proto.PromptGetBulkResponse> {
    return this.Post('getbulk', request, proto.PromptGetBulkResponse);
  }

  public async List(prompt_project: string): Promise<proto.PromptListResponse> {
    return this.Get(`list/${prompt_project}`, proto.PromptListResponse);
  }
  public async Render(
    request: proto.RenderRequest
  ): Promise<proto.RenderResponse> {
    return this.Post('render', request, proto.RenderResponse);
  }
  public async ProjectRender(
    request: proto.ProjectRenderRequest
  ): Promise<proto.ProjectRenderResponse> {
    return this.Post('ProjectRender', request, proto.ProjectRenderResponse);
  }

  public async GetProjectPrompts(projectId: string) {
    const { ids } = await this.List(projectId);
    const { Prompts } = await this.GetBulk(
      new proto.PromptGetBulkRequest({ ids })
    );
    return Prompts;
  }
}
